import { ReactNode } from 'react';
import { noop } from 'utils/noop';
import { useAssetManagerContext } from 'modules/assetManager/contexts/BaseAssetManagerContext';
import { MessageMedium } from 'modules/graphql/types';
import { useMessageTypesByMedium } from 'modules/templateEditor/hooks/useMessageTypesByMedium';

import { getOptInOnlyMessageTypes, transformToInput } from '../SmsSmartOptInModal.utils';
import { SmsSmartOptInLink } from '../types';
import { useTemplateSenders } from '../useTemplateSenders';
import { SmsSmartOptInContext, SmsSmartOptInContextState } from './SmsSmartOptInContext';

type SmsSmartOptInContextProviderProps = {
  children?: ReactNode;
};

export const SmsSmartOptInProvider = ({ children }: SmsSmartOptInContextProviderProps) => {
  const { results: smsMessageTypes } = useMessageTypesByMedium({
    variables: { messageMedium: MessageMedium.SMS },
  });

  const { data } = useTemplateSenders();
  const smsSenders = data?.smsSenders ?? [];

  const optInOnlyMessageTypes = getOptInOnlyMessageTypes(smsMessageTypes);

  const {
    assets,
    assetTypeName,
    isModalOpen,
    isEditing,
    changesMade,
    selectedAssetId,
    assetDetails,
    assetErrors,
    onSearch,
    selectAssetInList,
    handleClose,
    createNew,
    save,
    cancel,
    setIsModalOpen,
    setIsEditing,
    setChangesMade,
    updateAssetDetails,
    updateAssetErrors,
  } = useAssetManagerContext();

  const context: SmsSmartOptInContextState = {
    assets: assets as SmsSmartOptInLink[],
    smsSenders,
    messageTypes: optInOnlyMessageTypes,
    assetTypeName,
    isModalOpen,
    isEditing,
    changesMade,
    selectedAssetId,
    assetDetails,
    assetErrors,
    onSearch,
    selectAssetInList,
    handleClose,
    createNew,
    save: () => save(transformToInput),
    cancel,
    setIsModalOpen,
    setIsEditing,
    setChangesMade,
    updateAssetDetails,
    updateAssetErrors,
    // This is not yet implemented
    deleteAsset: noop,
  };

  return <SmsSmartOptInContext.Provider value={context}>{children}</SmsSmartOptInContext.Provider>;
};
